const faFileVideo = {
  prefix: 'fal',
  iconName: 'file-video',
  icon: [
    384,
    512,
    [],
    'f1c8',
    'M64 32l128 0 0 96c0 35.3 28.7 64 64 64l96 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32zM224 45.3L338.7 160 256 160c-17.7 0-32-14.3-32-32l0-82.7zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L242.7 18.7C230.7 6.7 214.5 0 197.5 0L64 0zM208 288l0 96-96 0 0-96 96 0zm0 128c16.6 0 30.2-12.6 31.8-28.7l16 13.7c5.3 4.5 12 7 19 7 16.1 0 29.2-13.1 29.2-29.2l0-85.6c0-16.1-13.1-29.2-29.2-29.2-7 0-13.7 2.5-19 7l-16 13.7C238.2 268.6 224.6 256 208 256l-96 0c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0zm64-116.7l0 73.4-32-27.4 0-18.6 32-27.4z',
  ],
};
export default faFileVideo;
